import classnames from "classnames";
import React, { useCallback, useState } from "react";
import Swiper from "swiper";
import CarouselButton from "../../components/CarouselButton/CarouselButton";
import { useString } from "../../i18n/GetText";
import { useIsRtl } from "../../utils/LayoutContext";
import { Col, Row } from "../Grid";
import SwiperCarousel from "../SwiperCarousel/SwiperCarousel";
import styles from "./CampaignsCarousel.module.scss";

interface CampaignsCarouselProps {
  className?: string;
  children: JSX.Element[];
}

const CampaignsCarousel = ({
  children: slides,
  className
}: CampaignsCarouselProps) => {
  const isRtl = useIsRtl();
  const [swiper, setSwiper] = useState<Swiper>();
  const handleClick = useCallback(
    (direction: "next" | "prev") => {
      if (swiper) {
        if (direction === "next") {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
      }
    },
    [swiper]
  );
  const previousString = useString("previous");
  const nextString = useString("next");

  return (
    <Row className={classnames(styles.root, className)} justify="center">
      <Col sm={1} md={1} className={styles.buttonCol}>
        {slides.length > 1 && (
          <CarouselButton
            aria-label={previousString}
            direction={isRtl ? "right" : "left"}
            size="large"
            onClick={() => handleClick("prev")}
          />
        )}
      </Col>
      <Col md={8} sm={10}>
        <SwiperCarousel
          carouselItems={slides}
          itemTypeMessage="campaigns"
          centeredSlides
          slidesPerView={1}
          loop
          onSwiper={swiper => setSwiper(swiper)}
          speed={500}
        />
      </Col>
      <Col md={1} sm={1} className={styles.buttonCol}>
        {slides.length > 1 && (
          <CarouselButton
            aria-label={nextString}
            direction={isRtl ? "left" : "right"}
            size="large"
            onClick={() => handleClick("next")}
          />
        )}
      </Col>
    </Row>
  );
};
export default CampaignsCarousel;
